// @ts-nocheck
import Vue from "vue";
Vue.directive("uppercase", {
  bind(el, _, vnode) {
    el.addEventListener("input", (e) => {
      e.target.value = e.target.value.toUpperCase();
      vnode.componentInstance.$emit("input", e.target.value.toUpperCase());
    });
  }
});


Vue.directive("modal-content", {
  bind(el, _, vnode) {
    const store = vnode.context.$store;
    const maxHeightReducer = 200 + (store.state.app.window.height * 0.1);
    const newHeight = store.state.app.window.height - maxHeightReducer;
    //if (newHeight < (el).css('height')) {
      el.style.height = (newHeight) + "px";
      el.style.overflow = "auto";
    //}
    store.watch(() => store.state.app.window.height, (h) => {
      const maxHeightReducer = 116 + h * 0.1;
      const newHeight = store.state.app.window.height - maxHeightReducer;
      //if (newHeight < $(el).css('height')) {
        el.style.height = (newHeight) + "px";
        el.style.overflow = "auto";
      //}
    });
  }
});

Vue.directive("full-content", {
  bind(el, _, vnode) {
    const store = vnode.context.$store;
    el.style.height = (store.state.app.window.height + 100) + "px";//116
    el.style.overflow = "auto";
    store.watch(() => store.state.app.window.height, (h) => {
      const newHeight = h +100;//116
      el.style.height = (newHeight) + "px";
      el.style.overflow = "auto";
    });
  }
});

Vue.directive("click-outside", {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode?.context?.[binding.expression]?.(event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});